import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  Divider,
  Stack,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Add } from "@mui/icons-material";
import { displayRow } from "../../GlobalStyles";
import Template from "../exams/Template";
import { convertFirstUpper } from "../../Regex";
import AllForms from "./forms/AllForms";

export default function AddSubtopicsDialog({
  text,
  parent_name,
  parent,
  onSubmit,
  setAdd,
}: any) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (text === "QUESTION") {
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button
        sx={{ textTransform: "capitalize" }}
        onClick={handleOpen}
        variant="contained"
      >
        <Add sx={{ mr: "10px" }} />
        {convertFirstUpper(text.toLowerCase())}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, p: 1 },
        }}
      >
        {/* Title with Close Button */}
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 10px",
            borderBottom: "1px solid #e5e7eb",
            color: "#111827",
            fontSize: "20px",
          }}
        >
          Create a new {convertFirstUpper(text.toLowerCase())}
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: "10px" }}>
          <Stack spacing={3} alignItems="center">
            {/* Pick a Template */}

            <Template
              label={text.toLowerCase()}
              onSubmit={() => {
                onSubmit();
                handleClose();
              }}
              parent={parent}
              parent_name={parent_name}
            />

            <Divider flexItem>OR</Divider>

            {/* Create New Button */}
            <Button
              fullWidth
              variant="contained"
              sx={{
                borderRadius: 2,
                py: 1.5,
                textTransform: "capitalize",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
              onClick={() => {
                setAdd(true);
                handleClose();
              }}
            >
              <Box sx={{ ...displayRow, gap: "5px" }}>
                <Add /> Create New
              </Box>
              <>Create {text} from Scratch</>
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
}
